import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductPaxes', request)
}

async function post(request) {
    return await postMethod('/api/ownProductPaxes', request)
}

async function put(request) {
    return await putMethod('/api/ownProductPaxes', request)
}

export {get, post, put}
